/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
class t{static from(e){let n=0,r=0,o=0;return e.forEach((t=>{const e=t._readGeometry();e&&(r+=e.isPoint?1:e.lengths.reduce(((t,e)=>t+e),0),o+=e.isPoint?1:e.lengths.length,n+=1)})),new t(n,r,o)}constructor(t,e,n){this.featureCount=t,this.vertexCount=e,this.ringCount=n}toJSON(){return{featureCount:this.featureCount,ringCount:this.featureCount,vertexCount:this.featureCount}}}export{t as FeatureStoreStatistics};
